export const style = {
  leftToRight: {
    transform: `translate3d(-1000px, 0, 0)`
  },
  topToBottom: {
    transition: `all 0.5s cubic-bezier(0.77, 0, 0.175, 1)`,
    transitionDelay: `0.8s`,
    transform: `translate3d(0, -1000px, 0)`
  },
  transformActive: {
    transform: `translate3d(0, 0, 0)`
  },
  fadeOut: {
    position: `absolute`,
    top: 0,
    left: 0,
    transition: `0.2s ease-in-out`
  },
  fadeOutHide: {
    transitionDelay: `0.2s`,
    pointerEvents: `none`,
    opacity: 0
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/partials/Slideshow/style/animation.js